import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ItemEntry } from '../../../core/quotes.model';

@Injectable({
  providedIn: 'root',
})
export class QuoteListService {
  entries$ = new BehaviorSubject<ItemEntry[]>([
    // {
    //   code: new Date().toString(),
    //   qty: 1,
    //   reqPrice: '100',
    //   product: {
    //     name: 'Custom Product',
    //     speedRPM: '',
    //     outputHP: '',
    //     voltage: '',
    //     frameSize: '',
    //     outputKW: '',
    //     mounting: '',
    //     phase: '',
    //     enclosure: '',
    //     application: '',
    //     isCustom: true,
    //   },
    // },
  ]);
}
